<template>
  <div class="page-guide">
    <el-steps :active="active" align-center>
      <el-step title="基本信息" description="填写抽取的基本信息" />
      <el-step title="自行推荐" description="根据您选择专业，自行推荐专家" />
      <el-step title="随机抽取需求" description="管理您的随机抽取的需求" />
      <el-step
        title="查看抽取专家范围"
        description="根据您选择的研究学科、二级专业等条件筛选的专家范围"
      />
      <el-step
        title="抽取结果"
        description="随机抽取的结果，请您指定【可参会】专家"
      />
      <el-step title="完成提交" description="确定无误，我要提交" />
    </el-steps>

    <div class="router-view">
      <router-view @loaded="onloaded"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 1
    };
  },
  methods: {
    onloaded(active) {
      this.active = active;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-guide {
  margin-top: 50px;
  .router-view {
    padding: 50px;
    margin: 0px auto;
  }
}
</style>
